import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.amazonS3Compatible.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AmazonS3Compatible_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AmazonS3Compatible_DisplayText)
    ]
})
export class AmazonS3CompatibleLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly ACCESS_KEY_ID: IAttribute;
    public static readonly ACCESS_KEY: IAttribute;
    public static readonly SERVICE_URL: IAttribute;
    public static readonly FORCE_PATH: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessKeyID,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'ACCESS_KEY_ID',
        accepts: ['String'],
        templatable: true
    })
    public accessKeyId?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AmazonAccessKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'ACCESS_KEY',
        templatable: true,
        accepts: ['String']
    })
    public secretAccessKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServiceUrl,
        association: 'SERVICE_URL',
        templatable: true
    })
    public serviceUrl?: string;

    @Metamodel.attribute({
        display: stringResources.forcePathStyle,
        association: 'FORCE_PATH',
        templatable: true,
        accepts: ['Bool']
    })
    public forcePathStyle?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
